import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from '../../MaterialIcon';

import {hideModal} from "../../../actions/nodeEditorPanelActions";
import SelectBoxWithLabel from "../components/SelectBoxWithLabel";
import Axios from "axios";
import getAxiosConfig from "../../../utils/axiosConfig";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import {showToastForBackend} from "../../../actions/toastActions";
import SelectBox from "../components/SelectBox";
import ToggleableContent from "../components/ToggleableContent";
import CheckBox from "../components/CheckBox";
import InputWithLabel from "../components/InputWithLabel";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import messageCodes from "../../../utils/messageCodes";
import PanelLayout from "../components/PanelLayout";


class PredictorFirstBlockPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            predictors: [],
            itemProperties: [],
            predictorFirstBlockOptions: {
                predictorName: "",
                predictorContextItemsPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                predictorContextUserPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                isMaxResultsSelected: true,
                isContextItemsPropertyNameSelected: false,
                isContextUserPropertyNameSelected: false,
                outputDynamicPropertyName: "",
                maxResults: "500",
                settings: {}
            },
            selectedTab: "NodeDetail"
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
    }


    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.predictorFirstBlockOptions && this.props.clickedNodeInfo.extras.options.predictorFirstBlockOptions.predictorName !== null) {
            this.setState({predictorFirstBlockOptions: this.props.clickedNodeInfo.extras.options.predictorFirstBlockOptions}, () => {
                this.updateOptions();
            });
        } else {
            this.updateOptions();
        }
        //For SelectBox component
        let config = getAxiosConfig();
        config["params"] = {firstBlock: true};
        Axios.get(this.props.properties.logicUrl + "/predictors", config)
            .then(predictorList => {
                let predictorListSorted = predictorList.data.sort(
                    (a, b) => a.readableName > b.readableName ? 1 : -1
                );
                if (this.state.predictorFirstBlockOptions.predictorName === "") {
                    this.setState(prevState => ({
                        predictors: predictorListSorted,
                        predictorFirstBlockOptions: {
                            ...prevState.predictorFirstBlockOptions,
                            predictorName: predictorListSorted[0].predictorName
                        }
                    }), () => {
                        this.updateOptions();
                    });
                } else {
                    this.setState({predictors: predictorListSorted});
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
        Axios.get(this.props.properties.databaseUrl + "/properties/items", config)
            .then(response => {
                this.setState({
                    itemProperties: response.data.sort()
                });
            })
            .catch(err => {
                if (err.response)
                    this.props.showToastForBackend(err.response.data);
                else
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            });
    }

    updateOptions() {
        const predictorFirstBlockOptions = this.state.predictorFirstBlockOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options.predictorFirstBlockOptions = predictorFirstBlockOptions;
        this.props.clickedNodeAction(panelInfo);
    }

    handleChange(property, value) {
        this.setState(prevState => ({
            predictorFirstBlockOptions: {
                ...prevState.predictorFirstBlockOptions,
                [property]: value
            }
        }), () => {
            this.updateOptions();
        });
    }

    updateSettings(property, value) {
        this.setState(prevState => ({
            predictorFirstBlockOptions: {
                ...prevState.predictorFirstBlockOptions,
                settings: {
                    ...prevState.predictorFirstBlockOptions.settings,
                    [property]: value
                }
            }
        }), () => {
            this.updateOptions();
        });
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        const displaySettingAccordingToType = (settingValue, name, property) => {
            if (settingValue.type === "CONTEXT_PARAMETER") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.predictorFirstBlockOptions.settings[property] !== undefined ? this.state.predictorFirstBlockOptions.settings[property] : ""}
                                    selectArray={this.props.contextProperties.sort(
                                        (a, b) => a.name > b.name ? 1 : -1
                                    ).map(function (contextProperty) {
                                        return {label: contextProperty.name, value: contextProperty.name}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "OPTIONS") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.predictorFirstBlockOptions.settings[property] !== undefined ? this.state.predictorFirstBlockOptions.settings[property] : ""}
                                    selectArray={settingValue.options.sort(
                                        (a, b) => a.optionReadableName > b.optionReadableName ? 1 : -1
                                    ).map(function (option) {
                                        return {label: option.optionReadableName, value: option.optionid}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "ITEM_PROPERTY") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.predictorFirstBlockOptions.settings[property] !== undefined ? this.state.predictorFirstBlockOptions.settings[property] : ""}
                                    selectArray={this.state.itemProperties.map(function (itemProperty) {
                                        return {label: itemProperty, value: itemProperty}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "CONSTANT") {
                return <div className="filter-group">
                        <div className="filter-group-content">
                            <div className="filter-rule">
                                <InputWithLabel label={name + ":"}
                                                handleChange={(event) => this.updateSettings(property, event.target.value)}
                                                value={this.state.predictorFirstBlockOptions.settings[property] !== undefined ? this.state.predictorFirstBlockOptions.settings[property] : ""}
                                />
                            </div>
                        </div>
                    </div>
            }
        };
        const selectedPredictors = this.state.predictors.filter(predictor => predictor.predictorName === this.state.predictorFirstBlockOptions.predictorName);
        return (
            <PanelLayout>
                <SelectBoxWithLabel
                    selectValue={this.state.predictorFirstBlockOptions.predictorName}
                    selectArray={this.state.predictors.map(function (predictor) {
                        return {label: predictor.readableName, value: predictor.predictorName}
                    })}
                    handleChangeSelect={(event) => {
                        this.handleChange("predictorName", event.target.value);
                    }}
                    label="Predictor Type"/>
                <CheckBox
                    isSelected={this.state.predictorFirstBlockOptions.isContextItemsPropertyNameSelected}
                    toggleInput={() => this.handleChange("isContextItemsPropertyNameSelected", !this.state.predictorFirstBlockOptions.isContextItemsPropertyNameSelected)}
                    label="Item to Item Recommendation">
                    <div className="rule-container padded right-section">
                        <span className="select-label">Item Id Context Property:</span>
                        <SelectBox
                            handleChangeSelect={(event) => this.handleChange("predictorContextItemsPropertyName", event.target.value)}
                            selectValue={this.state.predictorFirstBlockOptions.predictorContextItemsPropertyName}
                            selectArray={this.props.contextProperties.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map(function (contextProperty) {
                                return {label: contextProperty.name, value: contextProperty.name}
                            })}/>
                    </div>
                </CheckBox>
                <CheckBox
                    isSelected={this.state.predictorFirstBlockOptions.isContextUserPropertyNameSelected}
                    toggleInput={() => this.handleChange("isContextUserPropertyNameSelected", !this.state.predictorFirstBlockOptions.isContextUserPropertyNameSelected)}
                    label="Item to User Recommendation">
                    <div className="rule-container padded right-section">
                        <span className="select-label">User Id Context Property:</span>
                        <SelectBox
                            handleChangeSelect={(event) => this.handleChange("predictorContextUserPropertyName", event.target.value)}
                            selectValue={this.state.predictorFirstBlockOptions.predictorContextUserPropertyName}
                            selectArray={this.props.contextProperties.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map(function (contextProperty) {
                                return {label: contextProperty.name, value: contextProperty.name}
                            })}/>
                    </div>
                </CheckBox>
                {selectedPredictors.length > 0 && selectedPredictors[0].possibleSettings.map((setting) => {
                    return displaySettingAccordingToType(setting.settingValue, setting.settingName.readableName, setting.settingName.id)
                })}
                <ToggleableContent label="Maximum Item Count"
                                   isSelected={this.state.predictorFirstBlockOptions.isMaxResultsSelected}
                                   onToggle={() => this.handleChange("isMaxResultsSelected", !this.state.predictorFirstBlockOptions.isMaxResultsSelected)}
                >
                    <div className="filter-rule">
                        <div className="input-container">
                            <input name="numberInput"
                                   onChange={(event) => this.handleChange("maxResults", event.target.value)}
                                   className="number-input" type="number"
                                   value={this.state.predictorFirstBlockOptions.maxResults}/>
                        </div>
                    </div>
                </ToggleableContent>
                <ContentWithTopLabel label="Output Score Name">
                    <InputWithLabel label="Output Dynamic Property Name:"
                                    handleChange={event => this.handleChange("outputDynamicPropertyName", event.target.value)}
                                    value={this.state.predictorFirstBlockOptions.outputDynamicPropertyName}
                    />
                </ContentWithTopLabel>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        content: state.modalInfo.content,
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {hideModal, showToastForBackend, clickedNodeAction})(PredictorFirstBlockPanel);